<style scoped>
.table {
  font-size: 85%;
  width: 100%;
}
</style>

<script>
/**
 * Baseline methods for all daily journal sub-tabs. Re-usable
 * methods go here, things like watching for property changes,
 * and standard prop setup.
 */
export default {
  props: {
    locationId: {
      default () {
        return 0
      }
    },
    dailyDate: {
      type: Date,
      default: new Date()
    },
    isActive: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  watch: {
    locationId: function (n, o) {
      if (n !== o) {
        this.loadData()
      }
    },
    isActive: function (n, o) {
      if (n !== o) {
        this.loadData()
      }
    },
    dailyDate: {
      handler: function (n, o) {
        if (n !== o) {
          this.loadData()
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * Override me
     */
    loadData: function () {
      return null
    }
  }
}
</script>
